import { KpInfoDto } from "./kpInfo.dto";

export class KpListDto {
    public date!: string;
    public infos: KpInfoDto[] = [];

    public setData(kpListDto: KpListDto): void {
        this.date = kpListDto.date;
        this.infos = kpListDto.infos;
    }

    public getNextSunriseKp(sunrise: string): number {
        for (let i = 0; i < this.infos.length; i++) {
            if (sunrise <= this.infos[i].timeTag) {
                return this.infos[i].kp;
            }
        }

        return 0;
    }
}